import { render, staticRenderFns } from "./ModalCategoriasDuplicadas.vue?vue&type=template&id=5a672c1f"
import script from "./ModalCategoriasDuplicadas.vue?vue&type=script&lang=js"
export * from "./ModalCategoriasDuplicadas.vue?vue&type=script&lang=js"
import style0 from "./ModalCategoriasDuplicadas.vue?vue&type=style&index=0&id=5a672c1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports